import { createSlice } from "@reduxjs/toolkit";

interface IState {
  modalMenuNavMobileIsActive: boolean;
}

const initialState: IState = {
  modalMenuNavMobileIsActive: false,
};

export const modal = createSlice({
  name: "modal",
  initialState,
  reducers: {
    handleModal: (state, action) => {
      switch (action.payload.typeModal) {
        case "menuNavMobile":
          state.modalMenuNavMobileIsActive = action.payload.display;
          break;
        default:
          break;
      }
    },
  },
});

export const { handleModal } = modal.actions;

export default modal.reducer;
